// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-phase-type__container{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: 16px 0;
}

.tournament-phase-type__title.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    border-bottom: 1px solid var(--new-gray-background-color);
    padding-left: 16px;
    padding-bottom: 16px;
}

.tournament-phase-type__example{
    padding-top: 8px;
    padding-left: 45px;
}

.tournament-phase-type__example .phases-example{
    padding-left: 20px;
    padding-top: 8px;
}

.tournament-phase-type__example .phases-example-ident{
    padding-left: 19px;
}

.tournament-phase-type__example.baloa-names{
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.tournament-phase-type__phase-type-subtitle{
    padding-left: 24px;
    padding-top: 20px;
    padding-bottom: 20px;
}

.tournament-phase-type__phase-type-subtitle.baloa-names{
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.tournament-phase-type .baloa-username {
    color: var(--primary-very-dark-color);
    padding-bottom: var(--space-half);
}

.tournament-phase-type .MuiFormGroup-root{
    flex-wrap: nowrap;
}

.MuiFormGroup-root.tournament-phase-type__option-button{
    padding: 0 24px;
}

.tournament-phase-type__option-button .MuiRadio-root{
    color: var(--new-gray-background-color);
}
.tournament-phase-type__option-button .MuiFormControlLabel-root{
    border-radius: 13px;
    border: 1px solid var(--new-gray-background-color);
    margin-left: 0;
    min-width: 145px;
}
.tournament-phase-type__option-button .MuiFormControlLabel-root.selected{
    border: 1px solid var(--new-green-color);
    margin-left: 0;
    min-width: 145px;
}

.tournament-phase-type__option-button .MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementStart{
    margin: 0;
    padding: var(--space-half-quarter) var(--space);
    margin-right: var(--space);
    justify-content: space-between;
    align-items: baseline;
}
.tournament-phase-type__three-buttons{
    width: 100%;
}
.tournament-phase-type__option-button {
    display: flex;
    justify-content: space-between;
}
.tournament-phase-type__three-buttons .tournament-phase-type__option-button .MuiFormControlLabel-root{
    margin: 0;
    width: 32%;
}
.tournament-phase-type__three-buttons span.baloa-username {
    color: var(--primary-very-dark-color);
    padding: var(--space) 0;
}

.tournament-phase-type__option-button-label img{
    width: 58px;
    margin-right: 18px;
}

/* .tournament-phase-type__option-button-label._disabled .tournament-phase-type__option-button-label__text-title.baloa-normal{
    color: var(--basic-gray-color);
} */

.tournament-phase-type__three-buttons._disabled{
    opacity: 0.64;
}

.tournament-phase-type__three-buttons .MuiFormGroup-root .MuiRadio-colorSecondary.Mui-checked{
    color: var(--new-green-color);
}

.tournament-phase-type__option-button-label__text{
    display: flex;
}

.tournament-phase-type__option-button-label__text-title.baloa-normal{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.tournament-phase-type__option-button-label__caption.baloa-table-column{
    color: var(--basic-gray-color);
    font-weight: var(--font-regular);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-phase-type/TournamentPhaseTypeComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,yDAAyD;IACzD,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uCAAuC;AAC3C;AACA;IACI,mBAAmB;IACnB,kDAAkD;IAClD,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,wCAAwC;IACxC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,+CAA+C;IAC/C,0BAA0B;IAC1B,8BAA8B;IAC9B,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;GAEG;;AAEH;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC","sourcesContent":[".tournament-phase-type__container{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: 16px 0;\n}\n\n.tournament-phase-type__title.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding-left: 16px;\n    padding-bottom: 16px;\n}\n\n.tournament-phase-type__example{\n    padding-top: 8px;\n    padding-left: 45px;\n}\n\n.tournament-phase-type__example .phases-example{\n    padding-left: 20px;\n    padding-top: 8px;\n}\n\n.tournament-phase-type__example .phases-example-ident{\n    padding-left: 19px;\n}\n\n.tournament-phase-type__example.baloa-names{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.tournament-phase-type__phase-type-subtitle{\n    padding-left: 24px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n}\n\n.tournament-phase-type__phase-type-subtitle.baloa-names{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.tournament-phase-type .baloa-username {\n    color: var(--primary-very-dark-color);\n    padding-bottom: var(--space-half);\n}\n\n.tournament-phase-type .MuiFormGroup-root{\n    flex-wrap: nowrap;\n}\n\n.MuiFormGroup-root.tournament-phase-type__option-button{\n    padding: 0 24px;\n}\n\n.tournament-phase-type__option-button .MuiRadio-root{\n    color: var(--new-gray-background-color);\n}\n.tournament-phase-type__option-button .MuiFormControlLabel-root{\n    border-radius: 13px;\n    border: 1px solid var(--new-gray-background-color);\n    margin-left: 0;\n    min-width: 145px;\n}\n.tournament-phase-type__option-button .MuiFormControlLabel-root.selected{\n    border: 1px solid var(--new-green-color);\n    margin-left: 0;\n    min-width: 145px;\n}\n\n.tournament-phase-type__option-button .MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementStart{\n    margin: 0;\n    padding: var(--space-half-quarter) var(--space);\n    margin-right: var(--space);\n    justify-content: space-between;\n    align-items: baseline;\n}\n.tournament-phase-type__three-buttons{\n    width: 100%;\n}\n.tournament-phase-type__option-button {\n    display: flex;\n    justify-content: space-between;\n}\n.tournament-phase-type__three-buttons .tournament-phase-type__option-button .MuiFormControlLabel-root{\n    margin: 0;\n    width: 32%;\n}\n.tournament-phase-type__three-buttons span.baloa-username {\n    color: var(--primary-very-dark-color);\n    padding: var(--space) 0;\n}\n\n.tournament-phase-type__option-button-label img{\n    width: 58px;\n    margin-right: 18px;\n}\n\n/* .tournament-phase-type__option-button-label._disabled .tournament-phase-type__option-button-label__text-title.baloa-normal{\n    color: var(--basic-gray-color);\n} */\n\n.tournament-phase-type__three-buttons._disabled{\n    opacity: 0.64;\n}\n\n.tournament-phase-type__three-buttons .MuiFormGroup-root .MuiRadio-colorSecondary.Mui-checked{\n    color: var(--new-green-color);\n}\n\n.tournament-phase-type__option-button-label__text{\n    display: flex;\n}\n\n.tournament-phase-type__option-button-label__text-title.baloa-normal{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.tournament-phase-type__option-button-label__caption.baloa-table-column{\n    color: var(--basic-gray-color);\n    font-weight: var(--font-regular);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
